<div class="row d-md-none">
  <div class="col">
    <h5 class="text-muted text-uppercase pb-3">
      {{ 'document-view-public.document-totals-table.document-total' | translate }}
    </h5>
  </div>
  <div class="col-12"><hr class="mt-0" /></div>
</div>

<!-- Discount -->
<div class="row" *ngIf="totalDiscount !== 0">
  <div class="col">
    <p>{{ 'document-view-public.document-totals-table.discount-total' | translate }}:</p>
  </div>
  <div class="col-auto text-right">
    <p id="total-discount">
      {{ totalDiscount * -1 | pepCurrency: currency:locale }}
    </p>
  </div>
  <div class="col-12"><hr class="mt-0" /></div>
</div>
<!-- // Discount -->

<!-- Total -->
<div class="row">
  <div class="col">
    <p [class.font-weight-bold]="totalWithTax === total">
      {{ 'document-view-public.document-totals-table.total' | translate }}:
    </p>
  </div>
  <div class="col-auto text-right">
    <p id="total">
      <strong *ngIf="totalWithTax === total; else notStrong">
        {{ total | pepCurrency: currency:locale:2 }}
      </strong>
      <ng-template #notStrong>
        {{ total | pepCurrency: currency:locale:2 }}
      </ng-template>
    </p>
  </div>
  <div class="col-12"><hr class="mt-0" /></div>
</div>
<!-- // Total -->

<!-- Taxes -->
<app-document-taxes-table
  [inForeignCurrency]="inForeignCurrency"
  [items]="items"
  [taxes]="taxes"
  [total]="total"
  [currency]="currency">
</app-document-taxes-table>
<!-- // Taxes -->

<!-- Equalization -->
<div class="form-group row mb-0" *ngIf="showEqualization">
  <div class="col-12" *ngIf="taxes && taxes.length">
    <hr class="mt-0" />
  </div>

  <ng-container *ngIf="equalizationCtrl">
    <label for="equalization" class="col-form-label col-auto"
      >{{ 'document-view-public.document-totals-table.equalization' | translate }}:</label
    >
    <div class="col-6 col-md-5 col-lg-4 ml-auto">
      <input
        autocomplete="chrome-off"
        type="text"
        class="form-control text-right"
        name="equalization"
        id="equalization"
        [formControl]="equalizationCtrl"
        *ngIf="equalizationCtrl"
      />
    </div>
  </ng-container>

  <ng-container *ngIf="!equalizationCtrl">
    <div class="col">{{ 'document-view-public.document-totals-table.equalization' | translate }}:</div>
    <div class="col-auto">
      {{ equalizationValue | pepCurrency: currency:locale:2 }}
    </div>
  </ng-container>

  <div class="w-100 mt-3 mb-2"></div>
</div>
<!-- // Equalization -->

<!-- Total w/ tax -->
<div class="row" *ngIf="totalWithTax !== total">
  <div class="col-12"><hr class="mt-0" /></div>
</div>

<div class="row" *ngIf="totalWithTax !== total">
  <div class="col">
    <p>
      <b> {{ 'document-view-public.document-totals-table.total-with-tax' | translate }}: </b>
    </p>
  </div>
  <div class="col-auto text-right">
    <p id="total-with-tax">
      <b>
        {{ totalWithTax | pepCurrency: currency:locale:2 }}
      </b>
    </p>
  </div>
  <div class="col-12"><hr class="mt-0" /></div>
</div>
<!-- // Total w/ tax -->
